module.exports = __webpack_public_path__ + "img/613f644.jpg";